// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QoN0","index":"styles_index__25G49"};